export default "__VITE_ASSET__BKmjTLsA__$_?no-inline__"